import { P2GGrid } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { BasketQuote } from '~/lib/types/basket-types';
import { QuoteFilterOptions } from '~/lib/quotes';
import QuoteFilterServiceType from './quote-filter-service-type';
import SortBy from './quote-filter-sort';
import RatingFilterOptions from './quote-filter-ratings';
import QuoteFilterPrinter from './quote-filter-printer';
import QuoteFilterDeliveryOptions from './quote-filter-delivery-options';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { PublicSettings } from '~/lib/ui-serverless-settings';

export default function QuoteFilterBase({
  filter,
  onChange,
  filteredQuotes,
  origin,
  destination,
  quotes
}: {
  origin?: string;
  destination?: string;
  filter: QuoteFilterOptions;
  onChange: (filter: QuoteFilterOptions) => void;
  filteredQuotes: BasketQuote[];
  quotes: BasketQuote[];
}) {
  const { settings } = useTenant();
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);

  return (
    <P2GGrid container dataTestId="quotes-filter" direction="column" gap={2}>
      {settings[PublicSettings.QUOTES.SORTENABLED] === 'true' && (
        <P2GGrid item>
          <SortBy
            filter={filter}
            onChange={onChange}
            dataTestId="quotes-filter-sort-type"
            label={t('FILTER_SORT_TYPE_TITLE', { defaultValue: 'Sort By' })}
          />
        </P2GGrid>
      )}

      {settings[PublicSettings.QUOTES.SERVICEOPTIONSENABLED] === 'true' && (
        <P2GGrid item>
          <QuoteFilterServiceType
            questions={false}
            title="Service Options"
            filter={filter}
            onChange={onChange}
            quotes={quotes}
          />
        </P2GGrid>
      )}

      {settings[PublicSettings.QUOTES.ESTIMATEDDELIVERYOPTIONSENABLED] === 'true' && (
        <P2GGrid item>
          <QuoteFilterDeliveryOptions
            origin={origin}
            destination={destination}
            dataTestId="quotes-filter-delivery-options"
            title={t('FILTER_DELIVERY_OPTIONS_TITLE', { defaultValue: 'Estimated Delivery' })}
            quotes={quotes}
            filteredQuotes={filteredQuotes}
            filter={filter}
            onChange={onChange}
          />
        </P2GGrid>
      )}

      {settings[PublicSettings.QUOTES.LABELOPTIONSENABLED] === 'true' && (
        <P2GGrid item>
          <QuoteFilterPrinter title="Label Printing" filter={filter} onChange={onChange} />
        </P2GGrid>
      )}

      {settings[PublicSettings.QUOTES.RATINGENABLED] === 'true' && (
        <P2GGrid item>
          <RatingFilterOptions
            dataTestId="quotes-filter-ratings"
            title={t('FILTER_RATINGS_TITLE', { defaultValue: 'Avg. Star Rating' })}
            filter={filter}
            onChange={onChange}
          />
        </P2GGrid>
      )}
    </P2GGrid>
  );
}
